import { useLiveQuery } from 'dexie-react-hooks'
import { useEffect, useMemo, useState } from 'react'

import { KanbanBoard } from '@/components/KanbanBoard'
import { OrderDrawer } from '@/components/OrderDrawer'
import { ScreenHeader } from '@/components/ScreenHeader'
import { useApp } from '@/context'
import { advanceComanda, getClienti, getComenzi, getMasini, getSoferi } from '@/db/queries'
import { fmtRON } from '@/lib/format'

export default function Comenzi() {
  const { activeTab, selectedId, setSelectedId } = useApp()

  const comenzi = useLiveQuery(() => getComenzi(), []) ?? []
  const clienti = useLiveQuery(() => getClienti(), []) ?? []
  const soferi = useLiveQuery(() => getSoferi(), []) ?? []
  const masini = useLiveQuery(() => getMasini(), []) ?? []

  const [openId, setOpenId] = useState<string | null>(null)

  // deep-link: another screen (Mesaje, cinematic) sets selectedId + navigates here
  useEffect(() => {
    if (activeTab === 'comenzi' && selectedId) {
      setOpenId(selectedId)
      setSelectedId(null)
    }
  }, [activeTab, selectedId, setSelectedId])

  const clientiById = useMemo(() => new Map(clienti.map((c) => [c.id, c])), [clienti])
  const soferiById = useMemo(() => new Map(soferi.map((s) => [s.id, s])), [soferi])
  const masiniById = useMemo(() => new Map(masini.map((m) => [m.id, m])), [masini])

  const active = comenzi.filter((c) => c.status !== 'Facturat')
  const valoareActiva = active.reduce((s, c) => s + c.totalRON, 0)

  return (
    <div>
      <ScreenHeader tab="comenzi">
        <div className="text-right">
          <p className="nums font-mono text-lg font-semibold leading-none text-amber-ink">
            {fmtRON(valoareActiva)}
          </p>
          <p className="mt-1 text-xs text-muted-foreground">{active.length} comenzi în lucru</p>
        </div>
      </ScreenHeader>

      <KanbanBoard
        comenzi={comenzi}
        clientiById={clientiById}
        soferiById={soferiById}
        masiniById={masiniById}
        onOpen={setOpenId}
        onAdvance={(id) => void advanceComanda(id)}
      />

      <OrderDrawer
        comandaId={openId}
        open={openId !== null}
        onOpenChange={(o) => {
          if (!o) setOpenId(null)
        }}
      />
    </div>
  )
}
